import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --color-primary: #24BA7D;
    --color-background: #081C21;
    --color-text: #FFFFFF;
    --color-text-secondary: #609F94;
    --color-surface: #162A29;
    --color-surface-darker: #1F3737;
    --color-divider: rgba(255, 255, 255, 0.12);
    --border-radius-sm: 8px;
    --border-radius-md: 16px;
    --border-radius-lg: 24px;
    --border-radius-xl: 48px;
    --font-family-main: 'Ubuntu', sans-serif;
    --font-family-secondary: 'Rubik', sans-serif;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: var(--font-family-main);
    font-size: 16px;
    background-color: var(--color-background);
    color: var(--color-text);
    min-height: 100vh;
    width: 100%;
  }

  body {
    overflow-x: hidden;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  input, button {
    border: none;
    outline: none;
    background: none;
  }
`;

export default GlobalStyles; 